/* eslint-disable no-console */
import { Dropdown, Menu, message } from "antd";
import React, { useCallback, useEffect, useState, useContext } from "react";
import { connect } from "dva";
import { useTranslation } from "react-i18next";
import { FocusSDK, isBjme, isFocusEnv } from "@/utils";
import log from "@/utils/logger";
import ChatState from "@/types/chat/State";
import Session from "@jd/jdee.im.sdk/lib/es/model/Session";
import SessionType from "@jd/jdee.im.sdk/lib/es/enum/SessionType";
import IconFont from "@/components/icon";
import Employee, { EmployeeAttribute } from "@jd/jdee.im.sdk/lib/es/model/Employee";
import { isCrossPlatformGroupSession } from "@/utils/chat/message";
import config, { ChatConfig, ConfigEnum, getNetCheckUrl } from "@/config/config";
import { getProjectDetail } from "@/api/chat";
import { Group } from "@/types/chat";
import { checkScheduleVisible, checkTaskVisible, checkRemindVisible } from "@/utils/chat/group";
import { openCreateSchedule, openCreateRemind } from "@/utils/chat/index";
import bus from "@/utils/bus";
import { PageType } from "@/components/Joyspace/const";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import ChatContext from "@/components/chat/context";
import { buildPagePathKey } from "@/components/Modals/JoyspaceFileSelectorModal/utils";
import "./index.less";
import { duccConfigI18 } from "@/utils/i18n";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
// eslint-disable-next-line no-duplicate-imports
// import { getNetCheckUrl } from "@/config/config";  // '@/config/config' import is duplicated
import i18n from "@/i18n";
import { UserModel } from "@/models/user";
import useShareUserCardInChat from "@/components/Modals/shareUserCardInChat";

const netServer = NetworkCheck.getInstance({
  url: getNetCheckUrl(),
  checkType: UseCheckType.API
});

const logger = log.getLogger("chat.Input.MoreDropdown");

function MoreDropdown({
  children,
  uploadFile,
  // handleUploadImgs,
  selectedSession,
  sendJoyspaceMessage,
  closeOtherModal,
  currentEmployee,
  openCreateModal,
  openCreateRemindModal,
  userData
}: {
  children: any;
  uploadFile: (file: any) => void;
  selectedSession: Session;
  sendJoyspaceMessage: (data: any[]) => void;
  closeOtherModal: () => void;
  currentEmployee: Employee;
  openCreateModal: Function;
  openCreateRemindModal: Function;
  userData: UserModel;
  // handleUploadImgs: Function;
}) {
  const [t] = useTranslation("chat");
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [tooltipVisible, settooltipVisible] = useState(false);
  const { appRuntimeEnv, authInfo } = useContext<GlobalContextConfig>(GlobalContext);
  const { im } = appRuntimeEnv;
  const { isSmall } = React.useContext(ChatContext);
  const shareUserCard = useShareUserCardInChat({
    currentEmployee,
    selectedSession,
    userData
  });
  function handleFileClick() {
    const input = document.createElement("INPUT");
    document.body.appendChild(input);
    input.setAttribute("type", "file");
    input.setAttribute("multiple", "true");
    input.onchange = (ev: any) => {
      if (ev.target.files && ev.target.files.length > 0) {
        uploadFile(ev.target.files);
      }
    };
    input.click();
    document.body.removeChild(input);
    // input.remove();
  }

  // 打开创建日程
  async function handleScheduleClick() {
    const params: any = {
      title: "",
      selectedSession: selectedSession
    };
    if (selectedSession.isGroup) {
      const { businessId, business } = selectedSession.info as Group;
      if (business && business?.indexOf("project") > -1) {
        // 专班群
        const [data, error] = await getProjectDetail({
          projectId: businessId,
          summary: true
        });
        if (data?.calendarId) {
          if (isFocusEnv()) {
            openCreateSchedule({
              calendarId: data.calendarId,
              ...params
            });
          } else {
            openCreateModal({
              visible: true,
              frozenCalendarId: data.calendarId,
              ...params
            });
          }
          return;
        }
      }
    }
    if (selectedSession.isSingle) {
      const {
        app,
        userId,
        teamId,
        labelInfoList,
        name: realName,
        avatar,
        employeeExt,
        unitName,
        deptName,
        titleName
      } = selectedSession.info as Employee;
      params.participant = [
        {
          app,
          ddAppId: app,
          userId,
          teamId,
          realName,
          headImg: avatar,
          labelInfoList,
          titleName: `${unitName ? unitName + "-" : ""}${deptName ? deptName + "-" : ""}${
            titleName || ""
          }`,
          userType: employeeExt?.userType
        }
      ];
    }
    if (isFocusEnv()) {
      openCreateSchedule({
        calendarId: "",
        ...params
      });
    } else {
      openCreateModal({
        visible: true,
        frozenCalendarId: "",
        ...params
      });
    }
  }
  // 打开创建任务
  async function handleTaskClick() {
    const onLine = await netServer.checkNet();
    if (!onLine) {
      message.error(i18n.t("Network Error"));
    }
    if (selectedSession.isGroup) {
      const { businessId, business, name } = selectedSession.info as Group;
      if (business && business?.indexOf("project") > -1) {
        bus.emit("task:open-create", {
          title: "",
          projectId: businessId,
          sourceName: name,
          selectedSession
        });
        return;
      }
    }
    bus.emit("task:open-create", {
      title: "",
      projectId: "",
      sourceName: "",
      selectedSession
    });
    // }
  }
  // 打开创建提醒
  async function handleRemindClick() {
    if (isFocusEnv()) {
      openCreateRemind({
        selectedSession: selectedSession,
        createData: {
          from: "IM"
        }
      });
    } else {
      openCreateRemindModal({
        visible: true,
        selectedSession: selectedSession,
        createData: {
          from: "IM"
        }
      });
    }
  }

  function handleShareCardClick() {
    return shareUserCard();
  }

  // 生成URL
  const caertJoySpaceLink = useCallback(
    (data: any) => {
      let content;
      if (data.pageType === PageType.Form) {
        // 低代码
        content = data.link;
        return content;
      }
      const { joyspaceHost } = appRuntimeEnv;
      const path = buildPagePathKey(data.pageType).subPath;
      const link = `${joyspaceHost}/${path}/${data.id}`;
      return `${link}`;
    },
    [appRuntimeEnv]
  );
  const callback = useCallback(
    ({
      status,
      callbackId,
      results
    }: {
      status: "ok" | "cancel";
      callbackId: string;
      results: any;
    }) => {
      console.log("callbacktest:baseCom", callbackId);
      const { sessionId } = selectedSession;
      if (selectedSession.sessionId !== callbackId) {
        return;
      }
      if (status === "cancel") {
        return;
      }
      if (results.length === 0) {
        return;
      }
      const list = results.map((item: any) => {
        return {
          content: "",
          icon: item.icon,
          title: item.title,
          type: item.type,
          pageType: item.pageType,
          id: item.id,
          permissionType: item.permissionType,
          url: caertJoySpaceLink(item)
        };
      });
      sendJoyspaceMessage(list);
    },
    [selectedSession, sendJoyspaceMessage, caertJoySpaceLink]
  );
  // 打开文档
  const handleJoySpaceClick = useCallback(() => {
    if (isFocusEnv()) {
      logger.debug("handleJoySpaceClick", selectedSession, currentEmployee);
      const { sessionType, sessionId, info } = selectedSession;
      let pin = sessionId;
      let teamId = "";
      let app = "";
      if ([SessionType.SINGLE, SessionType.SECRET_SINGLE].includes(sessionType)) {
        const employee = info as EmployeeAttribute;
        if (!employee) {
          logger.error("handleJoySpaceClick can not get uid", { sessionType });
          return;
        }
        pin = employee.userId;
        teamId = employee.teamId;
        app = employee.app;
      }
      if (sessionType === SessionType.GROUP) {
        teamId = currentEmployee.teamId;
        app = currentEmployee.app;
      }
      // FocusSDK.once("openJoyspaceDocSelector:result", callback);
      FocusSDK.emit("openJoyspaceDocSelector", { callbackId: selectedSession.sessionId, callback });
      // FocusSDK.shareDocuments(
      //     {
      //         pin,
      //         sessionType,
      //         teamId,
      //         app,
      //     },
      //     (data: any) => {
      //         logger.debug('shareDocuments result', data);
      //         sendJoyspaceMessage(data);
      //     }
      // );
    } else {
      FocusSDK.emit("openJoyspaceCloudSelector", {
        callbackId: "chat-cloud-file",
        callback: (data: any) => {
          console.log("data---", data);
          const { joyspaceApiHost } = appRuntimeEnv;
          const list = data.map((item: any) => {
            return {
              ...item,
              content: "",
              url: caertJoySpaceLink(item)
            };
          });
          sendJoyspaceMessage(list);
        }
      });
    }
  }, [callback]);
  function dropdownVisibleChange(visible: boolean) {
    // 点击+号 关闭常用语和@modal
    closeOtherModal();
    if (visible) {
      settooltipVisible(false);
    }
    setDropdownVisible(visible);
  }
  function tooltipVisibleChange(visible: boolean) {
    if (dropdownVisible && visible) {
      return;
    }
    settooltipVisible(visible);
  }
  const menu = (
    <Menu className={`chat-input-more-menu ${isSmall ? "small" : ""}`}>
      {config[ChatConfig.CHAT_MESSAGE_INPUT_FILE] && (
        <Menu.Item onClick={handleFileClick}>
          <div className="more-menu-operate-item">
            <IconFont
              className="chat-input-more-menu-icon iconic_app_more_file"
              type="iconic_app_more_file"
              clstag="pageclick|keycount|focus_chat_01_1615797500283|45"
            />
            <span className="menu-text">{isBjme() ? t("local-file") : t("file")}</span>
          </div>
        </Menu.Item>
      )}
      {config[ChatConfig.CHAT_MESSAGE_INPUT_JOYSPACE] &&
        // 解决移动端基于日程创建的群组，在pc端没有云文件入口的bug
        !(
          selectedSession.isSingle &&
          (selectedSession.info as EmployeeAttribute)?.app !== currentEmployee.app
        ) && (
          <Menu.Item onClick={handleJoySpaceClick}>
            <div className="more-menu-operate-item">
              <IconFont
                className="chat-input-more-menu-icon iconic_app_more_cloudspace"
                type="iconic_app_more_cloudspace"
                clstag="pageclick|keycount|focus_chat_01_1615797500283|47"
              />
              <span className="menu-text">
                {t("cloud-space", {
                  joyspace: duccConfigI18.joyspace
                })}
              </span>
            </div>
          </Menu.Item>
        )}
      {config[ChatConfig.CHAT_MESSAGE_INPUT_TASK] &&
        checkTaskVisible({ selectedSession }) &&
        config[ConfigEnum.EXTERNAL_CONTACTS_CREAT_TASK] && (
          <Menu.Item onClick={handleTaskClick}>
            <div
              className="more-menu-operate-item"
              clstag={`pageclick|keycount|xtbg_add_task|xtbg_add_task_createtask_source${
                selectedSession.isGroup ? "1" : "2"
              }`}
            >
              <IconFont
                className="chat-input-more-menu-icon iconic_app_more_task"
                type="iconic_app_more_task"
                // clstag="pageclick|keycount|focus_chat_01_1602584371145|47" //任务埋点而去掉
              />
              <span className="menu-text">{t("task_distribution")}</span>
            </div>
          </Menu.Item>
        )}
      {config[ChatConfig.CHAT_MESSAGE_INPUT_SCHEDULE] && checkScheduleVisible({ selectedSession }) && (
        <Menu.Item onClick={handleScheduleClick}>
          <div className="more-menu-operate-item">
            <IconFont
              className="chat-input-more-menu-icon iconic_app_more_schedule"
              type="iconic_app_more_schedule"
              clstag="pageclick|keycount|focus_chat_01_1615797500283|47"
            />
            <span className="menu-text">{t("schedule_share")}</span>
          </div>
        </Menu.Item>
      )}
      {config[ChatConfig.CHAT_MESSAGE_INPUT_REMIND] && checkRemindVisible({ selectedSession }) && (
        <Menu.Item onClick={handleRemindClick}>
          <div className="more-menu-operate-item">
            <IconFont
              className="chat-input-more-menu-icon iconic_app_more_remind"
              type="iconic_app_more_remind"
              clstag="pageclick|keycount|focus_chat_01_1602584371145|47"
            />
            <span className="menu-text">{t("warn")}</span>
          </div>
        </Menu.Item>
      )}
      {config[ChatConfig.CHAT_MESSAGE_INPUT_SHARE_CARD] && (
        <Menu.Item onClick={handleShareCardClick}>
          <div className="more-menu-operate-item">
            <IconFont
              className="chat-input-more-menu-icon iconic_app_more_file"
              type="iconic_app_businesscard"
            />
            <span className="menu-text">{t("share_card")}</span>
          </div>
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <Dropdown
      placement={window.innerWidth < 960 ? "topRight" : "topCenter"}
      overlay={menu}
      className="chat-input-more-dropdown"
      onVisibleChange={dropdownVisibleChange}
      trigger={["click"]}
      overlayClassName={`more-dropdown ${isSmall ? "small" : ""}`}
    >
      {/* <Tooltip
                title={t('more')}
                visible={tooltipVisible}
                onVisibleChange={tooltipVisibleChange}
                placement="bottom"
            > */}
      {children}
      {/* </Tooltip> */}
    </Dropdown>
  );
}

function mapStateToProps({ user, chat }: { user: any; chat: ChatState }) {
  const { selectedSession, currentEmployee } = chat as ChatState;
  return { selectedSession, currentEmployee, userData: user.userData ? user.userData.user : {} };
}

function mapDispatchToProps(dispatch: any) {
  return {
    openCreateModal(data: any) {
      dispatch({ type: "calendar/openCreateModal", payload: data });
    },
    openCreateRemindModal(data: any) {
      dispatch({ type: "supervise/setCreateModalVisible", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MoreDropdown);
